import React from "react"

import PropTypes from "prop-types"

import {
  Adornment,
  BoldText,
  Column,
  ItemWrapper,
  PropertyListRoot,
  StyledListItem,
  Title,
  TitleWrapper,
  Wrapper,
} from "./components"
import { MuiIcon } from "../../atoms/mui-icon"

export const PropertyTable = ({ divider = true, items, title = false }) => {
  return (
    <>
      {title && (
        <Wrapper>
          <TitleWrapper>
            <Adornment>
              <MuiIcon.AssignmentTurnedIn />
            </Adornment>
            <Title>{title}</Title>
          </TitleWrapper>
        </Wrapper>
      )}
      <PropertyListRoot>
        {items.map((item) => (
          <StyledListItem
            key={item.title}
            content={
              <ItemWrapper>
                <Column>
                  {item.icon}
                  {item.title}
                </Column>
                <Column>
                  <BoldText>{item.value}</BoldText>
                </Column>
              </ItemWrapper>
            }
            ContentProps={{ disableTypography: true }}
            divider={divider}
          />
        ))}
      </PropertyListRoot>
    </>
  )
}

PropertyTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
    }),
  ),
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}
